import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Modal } from "antd";
import MyStore from "../../../index";
import { QuestionListItem } from "../../../../../../service/answerStore";
import GroupData from "../../GroupData";
import classNames from "classnames";
import { ModalProps } from "antd/lib/modal/Modal";
import lodash from "lodash-es";

interface DataModalInstance {}

interface DataModalProps extends ModalProps {
    onConfirm: (data: QuestionListItem[]) => void;
}

const selectModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onCancel, onConfirm, ...props }, ref) => {
        const [checked, setChecked] = useState<QuestionListItem[]>([]);
        const [step, setStep] = useState(0);
        const [postData, setPostData] = useState<QuestionListItem[]>([]);
        async function saveAction() {
            onConfirm(postData);
        }

        function groupChange(datas: QuestionListItem[]) {
            setPostData(datas);
        }

        const allScope = useMemo(() => {
            return lodash.reduce(
                postData,
                function (sum, n) {
                    return sum + (n?.scope ?? 0);
                },
                0
            );
        }, [postData]);

        const chooseTabFooter = (
            <div className={style.modalFooter}>
                <span className={style.choosed}>已选择</span>
                <span className={style.chooseCount}>{checked.length}</span>
                <span className={style.choosed}>个</span>
                {step === 1 && (
                    <React.Fragment>
                        <span
                            className={style.choosed}
                            style={{ marginLeft: 10 }}>
                            总分数
                        </span>
                        <span
                            className={style.chooseCount}
                            style={{ color: "red" }}>
                            {lodash.floor(allScope, 1)}
                        </span>
                        <span className={style.choosed}>分</span>
                    </React.Fragment>
                )}
                <Button className={style.onCancel} onClick={onCancel}>
                    取消
                </Button>
                {step === 0 && (
                    <Button
                        onClick={() => setStep(step => step + 1)}
                        className={style.randomFooterBtn}
                        disabled={checked.length === 0}
                        type="primary">
                        下一步
                    </Button>
                )}
                {step > 0 && (
                    <Button
                        onClick={() => setStep(step => step - 1)}
                        className={style.randomFooterBtn}
                        type="primary">
                        上一步
                    </Button>
                )}
                {step > 0 && (
                    <Button
                        onClick={saveAction}
                        className={style.randomFooterBtn}
                        type="primary">
                        确定
                    </Button>
                )}
            </div>
        );
        return (
            <Modal
                {...props}
                title="题库选题"
                width={step === 0 ? "90%" : 610}
                style={{ top: 30 }}
                className={style.root}
                onCancel={onCancel}
                footer={chooseTabFooter}>
                <div
                    className={classNames(
                        step === 0 && style.show,
                        style.hide
                    )}>
                    <MyStore type="window" onCheck={setChecked} />
                </div>
                {step === 1 && (
                    <GroupData data={checked} onChange={groupChange} />
                )}
            </Modal>
        );
    }
);

selectModal.displayName = "selectModal";
export default selectModal;
